import { render, staticRenderFns } from "./CourseTransfersForm.vue?vue&type=template&id=655cb78e&"
import script from "./CourseTransfersForm.vue?vue&type=script&lang=js&"
export * from "./CourseTransfersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports